<template>
  <div style="height:100%;" class="airList">
    <!-- 新风编辑-->
    <el-dialog title="编辑新风" :visible.sync="editShow" width="30%">
      <el-form label-position="left">
        <el-form-item :label="$store.state.module1.isChina?'设备名称':'Device name'" label-width="80px">
          <el-input auto-complete="off" v-model="xfName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
        <el-button type="primary" @click="configEdit()">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
      </div>
    </el-dialog>
    <!-- 添加新风 -->
    <el-dialog title="添加设备" :visible.sync="addShow" width="30%">
      <el-form label-position="left">
        <el-form-item :label="$store.state.module1.isChina?'设备名称':'Device name'" label-width="80px">
          <el-input auto-complete="off" v-model="addName"></el-input>
        </el-form-item>
        <el-form-item :label="$store.state.module1.isChina?'识别号':'Code'" label-width="80px">
          <el-input auto-complete="off" v-model="addCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
        <el-button type="primary" @click="configAdd()">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
      </div>
    </el-dialog>
    <!-- 传感设备-->
    <feelDev :width="width" :tableShow="tableShow" :feelDevs="feelDevs" :fcode="fcode" @refresh="getDev(fcode)"></feelDev>
    <div class="manage-header">
      <div><h3>{{$store.state.module1.isChina?'新风管理':'Fresh air management'}}</h3></div>
      <div style="position:relative;"><input type="text" :placeholder="$store.state.module1.isChina?'请输入新风名称':'Enter place name'" @input="filterList" v-model="searchWord"><i class="el-icon-search"></i></div>
    </div>
    <!-- 新风设备列表 -->
    <div class="areaList Radius" v-loading="loading">
      <comBox>
        <template v-slot:name>
          <h3>{{$store.state.module1.isChina?'新风列表':'Fresh air management device list'}}</h3>
        </template>
        <template v-slot:other>
          <el-button type="primary"  size="small" @click="addShow=true">{{$store.state.module1.isChina?'新增新风':'add New Device'}}</el-button>
        </template>
        <template v-slot:content>
          <div>
            <!-- 表格-->
          <el-table :data="areaDevList" style="width: 100%;">
            <el-table-column :label="$store.state.module1.isChina?list.c:list.e"  v-for="(list,index) in lists" :key="index" :width="width">
              <template slot-scope="scope">
                <span class="rowSpan" v-if="index===0">{{scope.row.name}}</span>
                <span class="rowSpan" v-else-if="index===1">{{scope.row.code}}</span>
                <span class="rowSpan" v-else-if="index===2">{{scope.row.area_id?scope.row.area_id:'无'}}</span>
                <span class="rowSpan" v-else-if="index===3">{{parseInt(scope.row.is_linkage)===1?$store.state.module1.isChina?'关联':'relation':$store.state.module1.isChina?'未关联':'Not associated'}}</span>
                <span class="rowSpan" v-else-if="index===4">{{scope.row.nums}}</span>
                <span class="rowSpan" v-else-if="index===5">{{scope.row.create_time}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$store.state.module1.isChina?'操作':'operation'" width="200">
              <template slot-scope="scope">
                 <div style="text-align: center;" class="option">
                  <span style="color: #1890FF;" @click="getDev(scope.row.code)">
                    {{$store.state.module1.isChina?'设备':'device'}}
                 </span>
                 <span style="color: #1890FF;" @click="$router.push('/devData' + scope.row.code)">
                   {{$store.state.module1.isChina?'绑定':'bing'}}
                </span>
                <span style="color: #1890FF;" @click="editXf(scope.row.code)">
                 {{$store.state.module1.isChina?'编辑':'edit'}}
                </span>
                <span style="color: #1890FF;" @click="deleteXf(scope.row.code)">
                  {{$store.state.module1.isChina?'删除':'delete'}}
                 </span>
                 </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="myPage">
            <el-pagination layout="prev, pager, next, jumper" :total="proDevNum" background  :current-page="currentPage" :page-size="8">
            </el-pagination>
          </div>
          </div>
        </template>
      </comBox>
    </div>
  </div>
</template>

<script>
import { stringTime, requestData } from '../../../assets/js/commont.js'
import comBox from '../../../components/comBox/comBox.vue'
import feelDev from '../../../components/feelDev/feelDev.vue'
export default {
  components: {
    comBox,
    feelDev
  },
  data () {
    return {
      addShow: false,
      xfName: '',
      addName: '',
      addCode: '',
      loading: false,
      editShow: false,
      areaDevs: null,
      width: 175,
      proDevNum: null,
      currentPage: 1,
      areaDevList: null,
      feelDevs: null,
      tableShow: false,
      fcode: '',
      searchWord: '',
      lists: [
        {
          c: '设备名',
          e: 'Device name'
        },
        {
          c: '设备号',
          e: 'Device num'
        },
        {
          c: '区域ID',
          e: 'Area ID'
        },
        {
          c: '关联状态',
          e: 'Association status'
        },
        {
          c: '关联数量',
          e: 'Associated quantity'
        },
        {
          c: '创建时间',
          e: 'Creation time'
        }
      ]
    }
  },
  mounted () {
    this.updateTable()
    var self = this
    window.onload = function () {
      self.updateTable()
    }
    window.onresize = function () {
      self.updateTable()
    }
  },
  methods: {
    // 删除新风
    deleteXf (code) {
      this.$confirm(this.$store.state.module1.isChina ? '确定删除此设备?' : 'Are you sure you want to delete?', this.$store.state.module1.isChina ? '提示' : 'Tips', {
        confirmButtonText: this.$store.state.module1.isChina ? '确定' : 'OK',
        cancelButtonText: this.$store.state.module1.isChina ? '取消' : 'Cancel',
        type: 'warning'
      }).then(() => {
        var data = {
          account: window.localStorage.getItem('account'),
          code: code,
          token: window.localStorage.getItem('token'),
          ts: stringTime(this.$myTime())
        }
        this.$http.post('https://www.airdaas.com/api/xf/dodelete', requestData(data)).then(data => {
          if (data.data.data === 'success') {
            this.getFreshairList()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        })
      })
    },
    // 添加新风
    configAdd () {
      if (this.addName && this.addCode) {
        var data = {
          account: window.localStorage.getItem('account'),
          code: this.addCode,
          name: this.addName,
          token: window.localStorage.getItem('token'),
          ts: stringTime(this.$myTime())
        }
        this.$http.post('https://www.airdaas.com/api/xf/doadd', requestData(data)).then(data => {
          if (data.data.data === true) {
            this.getFreshairList()
            this.addShow = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: '信息不完整',
          type: 'warning'
        })
      }
    },
    // 编辑新风
    editXf (code) {
      this.editShow = true
      this.fcode = code
    },
    // 编辑新风
    configEdit () {
      if (this.xfName) {
        var data = {
          account: window.localStorage.getItem('account'),
          code: this.fcode,
          name: this.xfName,
          token: window.localStorage.getItem('token'),
          ts: stringTime(this.$myTime())
        }
        this.$http.post('https://www.airdaas.com/api/xf/doedit', requestData(data)).then(data => {
          if (data.data.data === 'success') {
            this.getFreshairList()
            this.editShow = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: '新风名不可为空',
          type: 'warning'
        })
      }
    },
    // 筛选
    filterList () {
      this.areaDevList = this.areaDevs.filter(item => {
        return item.name.indexOf(this.searchWord) !== -1
      })
    },
    // 获取新分传感设备
    getDev (code) {
      this.fcode = code
      var data = {
        account: window.localStorage.getItem('account'),
        code,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime())
      }
      this.$http.post('https://www.airdaas.com/api/xf/getDevicesByFreshair', requestData(data)).then(data => {
        this.feelDevs = data.data.data
        this.tableShow = true
      })
    },
    updateTable () {
      var oWidth1 = document.body.clientWidth || document.documentElement.clientWidth
      this.width = 175 / 1496 * oWidth1
    },
    // 获取新风
    getFreshairList () {
      this.loading = true
      var data = {
        account: window.localStorage.getItem('account'),
        limit: 8,
        page: this.currentPage,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime())
      }
      this.$http.post('https://www.airdaas.com/api/xf/getFreshairList', requestData(data)).then(res => {
        this.loading = false
        this.proDevNum = res.data.meta.total_count
        if (res.data.data.length) {
          this.areaDevs = res.data.data
          this.areaDevList = this.areaDevs
        } else {
          this.$emit('hideAir')
        }
      })
    }
  },
  created () {
    this.getFreshairList()
  },
  watch: {
    currentPage () {
      this.$nextTick(() => {
        this.getFreshairList()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.manage-header{
    width:calc(100% + 0.48rem);
    height:1.76rem;
    transform:translate(-0.1rem,-0.1rem);
    background:white;
    box-shadow:inset 8px 8px 8px 2px rgba(0,0,0,0.04);
    text-align:left;
    padding-top:0.4rem;
    padding-left:0.4rem;
    h3{
        margin-bottom:0.2rem;
    }
    div:last-child{
        width:4rem;
        height:0.5rem;
        border:1px solid #ccc;
        border-radius:0.1rem;
        padding:0 0.2rem;
        line-height:0.5rem;
        display:flex;
        align-items:center;
        justify-content:space-between;
    }
    div:first-child{
      display:flex;
      align-items:baseline;
      span{
        color:#01A3FF;
        margin-left:0.2rem;
        font-weight:600;
        font-size:0.14rem;
      }
    }
}
.areaList{
  width:100%;
  height:calc(100% - 1.76rem);
  overflow:auto;

}
.rowSpan{
  display: inline-block;
  width:100%;
  text-align: center;
}
.myPage{
  margin-top:0.2rem;
}
.option{
   span{
    cursor:pointer;
    color: #1890FF;
  }
}
</style>
